import { BlockagesGoal } from "components/Dashboard/BaseInsight/MainDashboardScreenRectagles"
import { IBaseInsight } from "interface/baseInsight/baseInsight"
import { INotification } from "interface/notifications/notifications-interface"

export const isNotificationType = (
    output: INotification | Partial<IBaseInsight> | BlockagesGoal
): output is INotification => {
    return (output as INotification).isNewNotification !== undefined
}